import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

import './style.scss'

ModalConfirm.prototype = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  header: PropTypes.string,
  content: PropTypes.string,
  handleConfirm: PropTypes.func,
}

function ModalConfirm(props) {
  const {
    show,
    setShow,
    header,
    content,
    handleConfirm,
    runWhenClosedFunc,
    inforSave,
    contentDetails,
  } = props

  let handleClose = () => {
    setShow(false)
    if (runWhenClosedFunc) {
      runWhenClosedFunc()
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered className="ModalConfirm">
      <Modal.Header closeButton>
        <Modal.Title>
          <span>
            <i
              className="fa-light fa-triangle-exclamation mr-3"
              style={{ fontSize: 20, color: '#ff9f0e' }}
            ></i>
            {header}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {content}
        <div>{contentDetails}</div>
      </Modal.Body>
      <Modal.Footer>
        <div className="">
          <button
            className="btn btn-outline-secondary mr-4 px-8"
            onClick={handleClose}
          >
            Hủy bỏ
          </button>
          <button
            className="btn btn-danger btn-primary px-8"
            onClick={(e) => {
              handleClose()
              handleConfirm(e)
            }}
            disabled={inforSave?.disabled}
          >
            Đồng ý
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalConfirm
